var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"qrcode",staticClass:"qrcodeWrapper"},[_c('div',{staticClass:"qrcode-center",attrs:{"id":"qrcodeCon"}}),_c('van-image',{attrs:{"src":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }